import React from 'react';

import './auth.css';
import misc from '../../misc';

const SignupConfirm = props => {
  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <div className="col-md-6">
          <div className="text-center m-4">
            <img
              src={misc.images.logoGrey3}
              width="30"
              height="30"
              className="d-inline-block align-top"
              alt="Federation"
            />
            <h2 className="mb-1 d-inline-block align-bottom">&nbsp;Sign Up</h2>
          </div>

          <div className="alert alert-success" role="alert">
            Thank you. Please check your email now and click the confirmation
            link to complete the creation of your account.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupConfirm;



// WEBPACK FOOTER //
// ./src/modules/auth/components/SignupConfirm.js